// Program Offerings Images
import constants from '../constants'
import FullName from '../components/Signup/FullName'
// import HaveProductPurchased from '../containers/ViemaxProgram/Components/HaveProductPurchased'

// Services Icons
import CalenderIcon from '../assets/icons/calender.svg'
import LabTestIcon from '../assets/icons/lab-test.svg'
import SmartDeviceIcon from '../assets/icons/smart-device.svg'
import Gender from '../components/Signup/Gender'
import CityPicker from '../components/Signup/CityPicker'
import DateOfBirth from '../components/Signup/DateOfBirth'

// Logo Images
import { shopifyBcaUrl, viemaxImgUrls } from './viemax-constants'
import VerifyCode from '../containers/ViemaxProgram/Components/HaveProductPurchased/VerifyCode'
import {
  NAVIGATE_BOOK_APPOINTMENT,
  NAVIGATE_TO_PAGE_BY_URL,
  NAVIGATE_TO_SCREEN,
} from '../utils/helpers/ReactNativeEvents'

export const VIEMAX = {
  id: constants.CARE_PROGRAM_TYPE.VIEMAX,
  name: 'VieMax Program',
  drug_name: 'VieMax',
  campaign_link: `${process.env.REACT_APP_FE_URL}/programs/viemax-program`,
  medical_condition_group_id: null, // need to ask Ankur
  upload_report_type: 'viemax_report',
  onboarding_steps: [
    /* Zy-verify-code is disabled for now as per the client request,
      To Add it back, uncomment the code below */
    // {
    //   name: 'did_you_purchased_plan',
    //   hideButton: true,
    //   Component: HaveProductPurchased,
    // },
    {
      name: 'verify_code',
      hideButton: true,
      Component: VerifyCode,
    },
    {
      name: 'name',
      hideButton: true,
      Component: FullName,
    },
    {
      name: 'gender',
      hideButton: true,
      Component: Gender,
    },
    {
      name: 'address',
      hideButton: true,
      Component: CityPicker,
    },
    {
      name: 'dob',
      hideButton: true,
      Component: DateOfBirth,
    },
  ],
  success_image: viemaxImgUrls.successImageWithWoman,
  success_image_width: 220,
  logoWhite: viemaxImgUrls.logoWhite,
  partnerName: 'VieMax',
  services: [
    {
      icon: CalenderIcon,
      name: 'Book Appointment',
      description: 'With Nutritionist.',
      rn_event: NAVIGATE_BOOK_APPOINTMENT,
      navigationData: {},
    },
    {
      icon: LabTestIcon,
      name: 'Book Lab Tests',
      description: 'at exclusive offer prices.',
      rn_event: NAVIGATE_TO_SCREEN,
      navigationData: {
        navigation: 'DiagnosticStackScreen',
        paramValues: {},
      },
    },
    {
      icon: SmartDeviceIcon,
      name: 'Buy Smart Health Devices',
      description: 'at exclusive offer prices.',
      rn_event: NAVIGATE_TO_PAGE_BY_URL,
      navigationData: {
        url: shopifyBcaUrl,
        pageTitle: 'Back',
      },
    },
  ],
  success_message: () => (
    <>
      Powered by <b>GoodFlip</b> in partnership with
      <br /> <b>Viemax</b>. Your trusted health partner.
    </>
  ),
}
